import CatalogCoverImage from "../../../common/catalog/CatalogCoverImage";
import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";
import DetailInstructorBlock from "../../../common/detail/DetailInstructorBlock";
import DetailMetaList from "../../../common/detail/DetailMetaList";
import FreeBadge, { isFreeProduct } from "../../../common/badge/FreeBadge";
import { formatWebinarStartLabel } from "../../webinarStartDisplay";

export default function WebinarSummarySection({ webinar }) {
	const description = (webinar.description ?? "").trim();
	const instructors = webinar.instructors_detail ?? [];
	const startLabel = formatWebinarStartLabel(webinar);

	const metaItems = [
		startLabel
			? {
					label: "تاریخ شروع",
					value: startLabel,
					dir: "ltr",
				}
			: null,
	].filter(Boolean);

	return (
		<div
			dir="ltr"
			className="flex flex-row items-start gap-5 md:flex-col-reverse"
		>
			<DetailAccentCard
				ariaLabel={webinar.title}
				className="min-w-0 flex-1 md:w-full md:flex-none"
				bodyClassName="p-5 md:p-6"
			>
				<div dir="rtl" className="flex flex-col gap-4 text-right">
					<h1 className="font-Vazir-700 text-[20px] md:text-[22px] text-darkBlue leading-snug">
						{webinar.title}
					</h1>

					<div>
						<DetailSectionHeading className="mb-2 md:text-[15px]">
							اطلاعات وبینار
						</DetailSectionHeading>
						<div className="flex flex-col gap-3">
							{metaItems.length > 0 && (
								<DetailMetaList items={metaItems} columns={1} />
							)}
							<DetailInstructorBlock instructors={instructors} />
						</div>
					</div>

					{description ? (
						<div>
							<DetailSectionHeading className="mb-2 md:text-[15px]">
								توضیحات
							</DetailSectionHeading>
							<p className="font-Vazir-400 text-[14px] leading-relaxed text-darkBlue/70 whitespace-pre-line">
								{description}
							</p>
						</div>
					) : (
						<p className="font-Vazir-400 text-[14px] text-darkBlue/50">
							توضیحی ثبت نشده است.
						</p>
					)}
				</div>
			</DetailAccentCard>

			<DetailAccentCard
				ariaLabel="تصویر وبینار"
				className="w-[340px] shrink-0 md:mx-auto md:w-full md:max-w-[380px]"
				bodyClassName="relative p-4 md:p-5"
			>
				{isFreeProduct(webinar) && (
					<FreeBadge className="absolute right-7 top-7 z-10 md:right-8 md:top-8" />
				)}
				<CatalogCoverImage
					src={webinar.image_url}
					alt={webinar.title || ""}
					roundedClassName="rounded-[12px]"
					aspectClassName="aspect-[16/10]"
					fit="contain"
					className="bg-[#E8F4EC]"
					placeholder="▶"
				/>
			</DetailAccentCard>
		</div>
	);
}
